import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { canRenderInputForType } from '../_helpers/hideInputForType'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../../../components/form/CheckboxInput'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'

const BasicConfigSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange, handleSelectedQuestionChangeOnPath } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  const shouldRender = canRenderInputForType(selectedQuestion.questionType.name)
  const shouldRenderOption = shouldRender('questionOptions')

  if (!shouldRenderOption) return false

  return (
    <>
      <Title size="h6" color={COLORS.dark4}>
        {t('questionSettings')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      {!['informative'].includes(selectedQuestion.questionType.name) && (
        <CheckboxInput
          label={t('required')}
          value={selectedQuestion.required}
          onChange={handleSelectedQuestionChange('required')}
        />
      )}

      {['sign'].includes(selectedQuestion.questionType.name) && (
        <>
          <CheckboxInput
            label={t('requiredDocument')}
            value={selectedQuestion.data?.requiredDoc}
            onChange={handleSelectedQuestionChangeOnPath(['data', 'requiredDoc'])}
          />
          <CheckboxInput
            label={t('useSavedUserSignature')}
            value={selectedQuestion.data?.useSavedUserSignature}
            onChange={handleSelectedQuestionChangeOnPath(['data', 'useSavedUserSignature'])}
          />
        </>
      )}

      <CheckboxInput
        label={t('confidential')}
        value={selectedQuestion.private}
        onChange={handleSelectedQuestionChange('private')}
      />

      {!['informative'].includes(selectedQuestion.questionType.name) && (
        <CheckboxInput
          label={t('allowNA')}
          value={selectedQuestion.allowNull}
          onChange={handleSelectedQuestionChange('allowNull')}
        />
      )}

      {['stock'].includes(selectedQuestion.questionType.name) && (
        <CheckboxInput
          label={t('allowOnlyQrCodeOperations')}
          value={selectedQuestion.data?.allowOnlyQrCode}
          onChange={handleSelectedQuestionChangeOnPath(['data', 'allowOnlyQrCode'])}
        />
      )}

      {['select', 'multiple'].includes(selectedQuestion.questionType.name) && (
        <CheckboxInput
          label={t('displayAsDropdown')}
          value={selectedQuestion.data?.displayAsList}
          onChange={handleSelectedQuestionChangeOnPath(['data', 'displayAsList'])}
        />
      )}
      {['user', 'asset', 'place'].includes(selectedQuestion.questionType.name) && (
        <CheckboxInput
          label={t('allowMultipleSelection')}
          value={selectedQuestion.data?.multiple}
          onChange={handleSelectedQuestionChangeOnPath(['data', 'multiple'])}
        />
      )}
      {['text'].includes(selectedQuestion.questionType.name) && (
        <>
          <CheckboxInput
            label={t('noLineBreak')}
            value={selectedQuestion.data?.simpleInput}
            onChange={handleSelectedQuestionChangeOnPath(['data', 'simpleInput'])}
          />
          <CheckboxInput
            label={t('useMarkdown')}
            value={selectedQuestion.data?.useMarkdown}
            onChange={handleSelectedQuestionChangeOnPath(['data', 'useMarkdown'])}
          />
        </>
      )}
      {!['sign', 'action_plan', 'block', 'informative'].includes(selectedQuestion.questionType.name) && (
        <>
          <CheckboxInput
            label={t('dontAllowReview')}
            value={selectedQuestion.data?.skipReview}
            onChange={handleSelectedQuestionChangeOnPath(['data', 'skipReview'])}
          />
        </>
      )}
      {['asset'].includes(selectedQuestion.questionType.name) && (
        <CheckboxInput
          label={t('filterByActivityPlace')}
          value={selectedQuestion.data?.filterByPlace}
          onChange={handleSelectedQuestionChangeOnPath(['data', 'filterByPlace'])}
        />
      )}
    </>
  )
}

export default BasicConfigSection
